const menu = {
    label: 'Parâmetros',
    icon: 'pi pi-fw pi-cog',
    to: '/rdstation/parametros',
    rules: ['RD-PARAMETROS-00'],
};

export default menu;
